// This directive shows an area graph representing the video inputs of a BoxCaster Pro. Different
// colors are used to represent different input types.
angular.module('app.directives').directive('appBoxcasterProVideoInputsGraph', $location =>
    ({
        require: '^^appBoxcasterGraph',
        restrict: 'E',
        scope: {
            statsData: '=',
            boxcasterId: '@',
            which: '@'
        },
        controller($scope) {
            $scope.options = {
                renderer: 'area',
                interpolation: 'step-after',
                height: 40,
                min: 0,
                max: 1
            };
            $scope.series = [{
                name: 'present',
                data: [],
                color: '#f000000'
            }];
            return $scope.$watch('statsData', function(newval, oldval) {
                if (newval != null) {
                    // TODO: This function is horribly inefficient.

                    // Search for requested adv7842 data targets
                    let data = {
                        framerate: newval[`${$scope.which}.framerate`],
                        height: newval[`${$scope.which}.height`],
                        width: newval[`${$scope.which}.width`]
                    };

                    // Pluck just the times and sort them
                    let times = _.union(_.keys(data.framerate), _.keys(data.height), _.keys(data.width));
                    times.sort((a, b) => a - b);

                    // Now iterate through the times and construct series data for each series for each time
                    let seriesData = [];
                    _.each(times, function(t) {
                        t = parseInt(t);
                        let framerate = (data.framerate || [])[t];
                        let height = (data.height || [])[t];
                        let width = (data.height || [])[t];
                        return seriesData.push({ x: t, y: ((framerate * height * width > 0) ? 1 : 0) });
                    });

                    $scope.series[0].data.length = 0;
                    return Array.prototype.push.apply($scope.series[0].data, seriesData.sort((a, b) => a.x - b.x));
                }
            });
        },

        link(scope, element, attrs, appBoxcasterGraph) {
            return appBoxcasterGraph.registerGraphWidthCallback(newWidth =>
                scope.$apply(() => scope.options.width = newWidth)
            );
        },

        template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
    }));


// WEBPACK FOOTER //
// ./directives/boxcaster_pro_video_inputs_graph.js